import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay"]

  connect() {
    console.log("MobileSideNav Stimulus controller connected!");
  }

  open() {
    console.log("Mobile side nav open triggered!");
    this.drawerTarget.classList.remove("-translate-x-full")
    this.drawerTarget.classList.add("translate-x-0")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.add("opacity-40")
  }

  close() {
    this.drawerTarget.classList.add("-translate-x-full")
    this.drawerTarget.classList.remove("translate-x-0")
    this.overlayTarget.classList.remove("opacity-40")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
  }
}